import { Injectable } from '@angular/core';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewhomepageService {
  constructor(private contentful: ContentfulService) {}

  newHomePageData: any;
  private apiDesignPanelSubject$ = new BehaviorSubject<any>(null);
  public apiDesignPanel$ = this.apiDesignPanelSubject$.asObservable();
  getNewHomePageData() {
    // this.contentful
    //   .getEntries(
    //     Object.assign({
    //       content_type: PageId.landingPage,
    //       include: 10,
    //     })
    //   )
    //   .then(res => {
    //     let mod = res.items as Entry<any>[];
    //     this.newHomePageData = mod.filter(
    //       x => x?.fields['id'] == PageId.newhomepageTesting
    //     );
    //     const apiDesignPanel = this.newHomePageData[0]?.fields?.psProductSuite?.fields;
    //     if (apiDesignPanel) {
    //       this.apiDesignPanelSubject$.next(apiDesignPanel);
    //     }
    //   });
  }
}
